import { render, staticRenderFns } from "./DinamicField.vue?vue&type=template&id=1f3b4248&scoped=true"
import script from "./DinamicField.vue?vue&type=script&lang=js"
export * from "./DinamicField.vue?vue&type=script&lang=js"
import style0 from "./DinamicField.vue?vue&type=style&index=0&id=1f3b4248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3b4248",
  null
  
)

export default component.exports